module.exports = __webpack_public_path__ + "img/cases-brand-avic-9.27ac915e.jpg";